<template>
  <div class="ggh-print-container">
    <div class="ggh-print-content">
      <div class="print-header">
        <span>{{date}}总货单</span>
      </div>
      <div class="print-list">
        <div
          :class="[page.currpage<4?'print-item':'print-item print-item2']"
          v-for="(page,index) in pages"
          :key="index"
        >
          <div class="item-list">
            <div :class="[index > 1 ?'item-title theader2':'item-title']">名称</div>
            <div :class="[index > 1 ?'item-title theader2':'item-title']">数量</div>
          </div>
          <div class="item-list" v-for="item in page">
            <div class="item-name">{{item.title}}</div>
            <div class="item-number">{{item.num}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { OrderModel } from "@models/common/order";
import { ERR_OK } from "@/common";
import { dateFormat } from "@util/functions";
const orderModel = new OrderModel();

export default {
  computed: {
    pages() {
      const pages = [];
      this.list.forEach((item, index) => {
        const page = Math.floor(index / 47);
        let currpage = Math.floor(index / 47) + 1;
        if (!pages[page]) {
          pages[page] = [];
        }
        pages[page].push(item);
        pages[page]["currpage"] = currpage;
      });
      return pages;
    }
  },
  data() {
    return {
      list: [],
      date: "",
      merchname: ""
    };
  },
  methods: {
    getData() {
      orderModel.getPrintOrderData({}).then(res => {
        if (res.code == ERR_OK) this.list = res.data.data;
      });
    }
  },
  created() {
    this.getData();
    this.date = dateFormat("YYYY.mm.dd", new Date());
  }
};
</script>

<style lang="stylus" scoped>
.ggh-print-container {
  background: #fff;
}

.theader2 {
}

.ggh-print-content {
  max-width: 595px;
  min-height: 842px;
  margin: 0 auto;
  background: #fff;
  text-align: center;
}

.print-header {
  font-size: 24px;
  padding: 20px 0;
  font-weight: bold;
  text-align: center;
}

.print-list {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.print-item {
  display: flex;
  min-height: 100%;
  flex-direction: column;
  width: 33%;
}

.item-name {
  font-weight: bold;
  font-size: 12px;
}

.item-title {
}

.print-item2 {
  margin-top: 20px;
  height: 959px;
}

.item-number {
  font-size: 12px;
  font-weight: bold;
}

.item-list {
  margin-bottom: 0.1rem;
  display: flex;
  width: 70%;
  line-height: 1.3;
  justify-content: space-between;
}
</style>
